(() => {
  const motion = window.WTCTheme.motion;
  window.WTCTheme.register('[data-site-navigation]', (root) => {
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const navbar = root.querySelector('nav');
    const more = root.querySelector('[data-more-trigger]');
    const dropdown = root.querySelector('[data-more-panel]');
    const moreGroup = root.querySelector('[data-more-group]');
    const toggle = root.querySelector('[data-drawer-open]');
    const drawer = root.querySelector('dialog');
    let dropdownAnimation;
    let drawerAnimation;
    let closeTimer;
    let frame;
    let dropdownGeneration = 0;
    let closing = false;
    let previousOverflow = '';

    const setMore = async (open, restoreFocus = false) => {
      const current = ++dropdownGeneration;
      clearTimeout(closeTimer);
      dropdownAnimation?.cancel();
      more.setAttribute('aria-expanded', String(open));
      dropdown.inert = !open;
      if (restoreFocus) more.focus();
      if (open) dropdown.hidden = false;
      dropdownAnimation = motion.animate(dropdown, open ? [
        { opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' },
      ] : [{ opacity: 1 }, { opacity: 0 }], { duration: motion.duration('fast') });
      await motion.finished(dropdownAnimation);
      if (current === dropdownGeneration) dropdown.hidden = !open;
    };
    more.addEventListener('click', () => setMore(more.getAttribute('aria-expanded') !== 'true'), options);
    moreGroup.addEventListener('focusout', (event) => {
      if (!moreGroup.contains(event.relatedTarget)) setMore(false);
    }, options);
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && more.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        setMore(false, true);
      }
    }, options);
    document.addEventListener('click', (event) => {
      if (!moreGroup.contains(event.target) && more.getAttribute('aria-expanded') === 'true') setMore(false);
    }, options);

    const closeDrawer = async () => {
      if (!drawer.open || closing) return;
      closing = true;
      drawer.dataset.closing = '';
      toggle.setAttribute('aria-expanded', 'false');
      drawerAnimation?.cancel();
      drawerAnimation = motion.animate(drawer, [{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }]);
      await motion.finished(drawerAnimation);
      drawer.close();
    };
    toggle.addEventListener('click', () => {
      if (drawer.open || document.querySelector('dialog[open]')) return;
      previousOverflow = document.documentElement.style.overflow;
      drawer.showModal();
      document.documentElement.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
      drawerAnimation = motion.animate(drawer, [{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }]);
    }, options);
    drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-drawer-close]')) closeDrawer();
      if (event.target === drawer) {
        const rect = drawer.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right) closeDrawer();
      }
    }, options);
    drawer.addEventListener('keydown', (event) => motion.trapFocus(event, drawer), options);
    drawer.addEventListener('cancel', (event) => { event.preventDefault(); closeDrawer(); }, options);
    drawer.addEventListener('close', () => {
      closing = false;
      delete drawer.dataset.closing;
      document.documentElement.style.overflow = previousOverflow;
      toggle.setAttribute('aria-expanded', 'false');
      document.dispatchEvent(new Event('wtc:overlay-closed'));
    }, options);
    const onScroll = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        navbar.classList.toggle('is-scrolled', scrollY > 24);
        frame = null;
      });
    };
    const desktop = matchMedia('(min-width: 1024px)');
    desktop.addEventListener('change', () => { if (desktop.matches && drawer.open) closeDrawer(); }, options);
    window.addEventListener('scroll', onScroll, { passive: true, ...options });
    onScroll();
    return () => {
      controller.abort();
      clearTimeout(closeTimer);
      cancelAnimationFrame(frame);
      dropdownGeneration += 1;
      dropdownAnimation?.cancel();
      drawerAnimation?.cancel();
      if (drawer.open) {
        drawer.close();
        document.documentElement.style.overflow = previousOverflow;
      }
    };
  });
})();
